import { ComponentBase } from './component-base';
import { MenuItem, TreeNode } from 'primeng/api';
import { BaseService } from '../../services/base.service';
import { NotifierService } from '../../services/notifier.service';
import { OnInit, Injector, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomRouterService } from '../../services/custom-router.service';
import { takeUntil } from 'rxjs/operators';
import { ListHelperService } from '../../services/list-helper.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../services/common.service';
import { ExportService } from '../../services/export.service';
import { RequestCatalogType } from '../../../dapfood/common/constant';
import { Printd } from 'printd';
import { VsUserSettingsService } from '../../services/vs-user-settings.service';
import { VsMySettingService } from '../../../services/ccmysetting.service';
import { VsMySetting } from '../../../models/ccmysetting';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { User } from '../../models/user';
import { DetailAddress } from '../../models/detailAddress.model';

const cssText = `
  @media print {
    table{
      border-collapse: collapse;
      width: 100%
    }
    .hidden{
        display: block;
    }
    tr > th{
      color:red;
      text-align: center;
      font-size:70%;
    }
    tr > td{
    }
    td, th {
      border: 1px solid black;
    }
    .vs-hidden-print, .ui-paginator-bottom{
        display:none;
    }
  }
`;


export abstract class SecondPageIndexBase extends ComponentBase implements OnInit {
    currentUser = new User;
    query = '';
    openSearchAdv = false;
    isCheckAll = false;
    isViewActivity = false;
    isViewSetting = false;
    ids = [];
    total = 0;
    page = 1;
    limit = 50;
    limitAll = 10000;
    cols = [];
    isMultiEdit = false;
    dataSource = [];
    dataExport = [];
    dataTotal = [];
    openSelectCheck = false;
    sortField = '';
    isAsc = false;
    isLoading = false;
    selectedItems = [];
    isCollapsed = false;
    isIgnoreClientCache = false;
    openColumnList = false;
    isViewList = true;
    arrTrangThai = [
        { label: 'Sử dụng', value: 1 },
        { label: 'Không Sử dụng', value: 2 },
        { label: '--Tất cả--', value: 0 },
    ];
    trangThai = 1;
    listItemNumberPerPage = [
        { label: '20', value: 20 },
        { label: '50', value: 50 },
        { label: '100', value: 100 },
        { label: '200', value: 200 },
        { label: '500', value: 500 },
        { label: '1000', value: 1000 },
    ];
    catalogType = RequestCatalogType
    exportName = 'dataExport';
    @ViewChild('columnListContainer')
    columnListContainerElement: ElementRef;

    @ViewChild('bulkSelectContainer')
    bulkSelectContainerElement: ElementRef;

    protected _activatedRoute: ActivatedRoute;
    protected _customRouterService: CustomRouterService;
    protected _listHelperService: ListHelperService;
    protected _commonService: CommonService;
    protected _translateService: TranslateService;
    protected _exportService: ExportService;
    protected _router: Router;
    protected _tnUserSettingsService: VsUserSettingsService;
    protected _mySettingService: VsMySettingService;
    mySetting = new VsMySetting();
    constructor(
        protected _baseService: BaseService,
        protected _injector: Injector
    ) {
        super();
        this._router = this._injector.get(Router);
        this._notifierService = this._injector.get(NotifierService);
        this._activatedRoute = this._injector.get(ActivatedRoute);
        this._customRouterService = this._injector.get(CustomRouterService);
        this._listHelperService = this._injector.get(ListHelperService);
        this._commonService = this._injector.get(CommonService);
        this._translateService = this._injector.get(TranslateService);
        this._exportService = this._injector.get(ExportService);
        this._tnUserSettingsService = this._injector.get(VsUserSettingsService);
        this._mySettingService = this._injector.get(VsMySettingService);
        this.onLoadSettings();
        this.mySetting = this._mySettingService.getCurrentSetting();
    }

    splitExportItems: MenuItem[] = [
        { label: 'Excel', icon: 'fa-light fa-file-excel' },
        { label: 'Word', icon: 'fa-light fa-file-word' }
    ];

    @HostListener('document:click', ['$event', '$event.target'])
    onClick(event: MouseEvent, targetElement: HTMLElement) {
        if (this.columnListContainerElement) {
            if (!this.columnListContainerElement.nativeElement.contains(targetElement)) {
                this.openColumnList = false;
            }
        }

        if (this.bulkSelectContainerElement) {
            if (!this.bulkSelectContainerElement.nativeElement.contains(targetElement)) {
                this.openSelectCheck = false;
            }
        }
    }

    ngOnInit(): void {
        this._activatedRoute.fragment
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((fragments) => {
                let query = this._customRouterService.parseFragment(fragments).searchKey;
                if (query === null || query === undefined) {
                    query = '';
                }
                this.query = query;
                this.getData();
            });
    }

    onLoadSettings() {
        // this._tnUserSettingsService.getSettingByUrl(environment.clientDomain.idPhanhe, this._router.url).then(rs => {
        //     if (rs.status) {
        //         this.mySettings = rs.data;
        //         this.openSearchAdv = this.mySettings.openSearchAdv;
        //         if (this.mySettings.cols) {
        //             this.cols = JSON.parse(this.mySettings.cols);
        //         }
        //         if (this.pSetting !== undefined) {
        //             this.pSetting.onLoadSetting(rs.data);
        //         }
        //     }
        // });
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    toggleSearch() {
        this.openSearchAdv = !this.openSearchAdv;
    }

    toggleSelectCheck(): void {
        this.openSelectCheck = !this.openSelectCheck;
    }

    getData() {
        // this.limit = this._listHelperService.getLimitByScreen();
        // this._baseService.get(this.query, ((this.page - 1) * this.limit), this.limit, this.sortField, this.isAsc, this.isIgnoreClientCache)
        //     .then(response => {
        //         this.dataSource = response.data;

        //         if (response.totalRecord || response.totalRecord === 0) {
        //             this.total = response.totalRecord;
        //         }

        //         this.afterGetData();

        //     }, error => {
        //         this._notifierService.showHttpUnknowError();
        //     });
    }

    exportToCSVIds() {
        if (this.ids.length === 0) {
            this._notifierService.showWarning('Bạn chưa chọn dòng để xuất dữ liệu');
        } else {
            const data = this.dataSource.filter(x => this.ids.indexOf(x.id) >= 0);
            this._commonService.exportToCSV(
                data,
                this.cols,
                'export.csv'
            );
        }
    }

    exportToCSV(fileName: string = 'export') {
        if (this.ids.length === 0) {
            this._notifierService.showWarning('Bạn chưa chọn dòng để xuất dữ liệu');
        } else {
            const data = this.dataSource.filter(x => this.ids.indexOf(x.id) >= 0);
            this._commonService.exportToCSV(
                data,
                this.cols,
                fileName + '.csv'
            );
        }
    }
    exportAllToCSV() {
        // this._baseService.Gets(this.query, 0, 10000, this.sortField, this.isAsc)
        //     .then(response => {
        //         this._commonService.exportToCSV(
        //             response.data,
        //             this.cols,
        //             'export.csv'
        //         );
        //     }, error => {
        //         this._notifierService.showHttpUnknowError();
        //     });
    }
    exportToExcel() {
        if (this.ids.length === 0) {
            this._notifierService.showWarning('Bạn chưa chọn dòng để xuất dữ liệu');
        } else {
            this._exportService.export(this.ids, this.cols, 'export');
        }
    }
    exportAllToExcel() {
        // this._baseService.Gets(this.query, 0, this.limitAll, this.sortField, this.isAsc)
        //     .then(response => {
        //         if (response.data.length === 0) {
        //             this._notifierService.showWarning('Không có dữ liệu để xuất !');
        //         } else {
        //             this._exportService.export(response.data, this.cols, 'export');
        //         }
        //     }, error => {
        //         this._notifierService.showHttpUnknowError();
        //     });
    }

    // exportPdf() {
    //     import("jspdf").then(jsPDF => {
    //         import("jspdf-autotable").then(x => {
    //             const doc = new jsPDF.default(0,0);
    //             doc.autoTable(this.exportColumns, this.cars);
    //             doc.save('primengTable.pdf');
    //         })
    //     })
    // }

    exportTdvExcel() {
        const data = [];
        console.log(this.dataSource);
        this.dataSource.forEach(item => {
            const row = {};
            this.cols.forEach(col => {
                if (!col.subHeaders) {
                    let celValue = item[col.field];
                    if (celValue !== null && celValue !== undefined && celValue !== '') {
                        if (col.dataType === 'date') {
                            celValue = moment.utc(celValue).format('YYYY-MM-DD HH:mm');
                        }
                        if (col.dataType === 'number') {
                            celValue = Number(celValue);
                            if (col.maximumFractionDigits === 0) {
                                celValue = Math.round(celValue);
                            }
                        }
                    }
                    row[col.header] = celValue;
                } else {
                    col.subHeaders.forEach(subCol => {
                        let subCelValue = item[subCol.field];
                        if (subCelValue !== null && subCelValue !== undefined && subCelValue !== '') {
                            if (subCol.dataType === 'date') {
                                subCelValue = moment.utc(subCelValue).format('YYYY-MM-DD HH:mm');
                            }
                            if (subCol.dataType === 'number') {
                                subCelValue = Number(subCelValue);
                                if (subCol.maximumFractionDigits === 0) {
                                    subCelValue = Math.round(subCelValue);
                                }
                            }
                        }
                        row[`${col.header} - ${subCol.header}`] = subCelValue;
                    });
                }
            });
            data.push(row);
        });
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, this.exportName);
    }

    exportExcel() {
        const data = [];
        this.dataSource.forEach(item => {
            const row = {};
            this.cols.forEach(col => {
                let celValue = item[col.field];
                if (celValue) {// Format Date
                    if (col.dataType === 'date') {
                        celValue = moment.utc(celValue).format('YYYY-MM-DD HH:mm');
                    }
                    // if (col.dataType === 'number') {
                    //     celValue = (celValue).toLocaleString('vi-VN', { maximumFractionDigits: 2 });
                    // }
                }
                if (col.field === 'location') {
                    celValue = `${item.lat}, ${item.lng}`;
                }
                // if (celValue) {// Format Date
                //     if (col.dataType === 'date') {
                //         const datePipe = new DatePipe('en-US');
                //         celValue = datePipe.transform(celValue, 'yyyy-MM-dd hh:mm');
                //     }
                //     if (col.dataType === 'number') {

                //         celValue = (celValue).toLocaleString('vi-VN', { maximumFractionDigits: 2 });
                //     }
                // }
                row[col.header] = celValue;
            });
            data.push(row);
        });
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, this.exportName);
    }

    exportExcelBangCongOffice(dataSource: any[], days: any[], cols: any[], fileName: string) {

        const headerRow1: any[] = [];
        const headerRow2: any[] = [];

        const fixedCols = cols.filter(c =>
            ['stt', 'code', 'codeDap', 'name', 'organization'].indexOf(c.field) >= 0 && c.visible
        );

        fixedCols.forEach(c => {
            headerRow1.push(c.header);
            headerRow2.push('');
        });

        days.forEach(d => {
            headerRow1.push(d.dayOfWeek);
            headerRow2.push(d.day + '/' + d.month);
        });

        const summaryCols = [
            { field: 'totalMinutesLate', header: 'Đi muộn', sub: 'Số phút' },
            { field: 'totalMinutesEarly', header: 'Về sớm', sub: 'Số phút' },
            { field: 'totalForgotInOut', header: 'Quên chốt', sub: 'Số lần' },

            { field: 'totalLeave', header: 'Nghỉ phép', sub: 'Đầu kỳ' },
            { field: 'userLeave', header: 'Nghỉ phép', sub: 'Sử dụng' },
            { field: 'remainingLeave', header: 'Nghỉ phép', sub: 'Cuối kỳ' },

            { field: 'totalWorkShift', header: 'Công', sub: 'Công ca' },
            { field: 'totalWorkHoliday', header: 'Công', sub: 'Công lễ' },
            { field: 'totalWorkTravel', header: 'Công', sub: 'Công công tác' },

            { field: 'otHolidayHours', header: 'Làm thêm', sub: 'Giờ ngày lễ' },
            { field: 'otOffDayHours', header: 'Làm thêm', sub: 'Giờ ngày nghỉ' },
            { field: 'otDayShiftHours', header: 'Làm thêm', sub: 'Giờ ngày ca' },
            { field: 'totalOtHour', header: 'Làm thêm', sub: 'Số giờ' },
            { field: 'otWork', header: 'Làm thêm', sub: 'Số công' },

            { field: 'totalWorkMonthHours', header: 'Tổng giờ', sub: '' },
            { field: 'totalWork', header: 'Tổng công', sub: '' }
        ];

        summaryCols.forEach(c => {
            headerRow1.push(c.header);
            headerRow2.push(c.sub);
        });

        const data: any[] = [];
        data.push(headerRow1);
        data.push(headerRow2);

        dataSource.forEach((user, index) => {
            const row: any[] = [];

            fixedCols.forEach(c => {
                if (c.field === 'stt') {
                    row.push(index + 1);
                } else {
                    row.push(user[c.field] !== undefined && user[c.field] !== null ? user[c.field] : '');
                }
            });

            // ==== CỘT NGÀY: NUMBER THUẦN ====
            user.days.forEach(d => {
                row.push(
                    d.workUnits !== undefined && d.workUnits !== null
                        ? Number(d.workUnits)
                        : null
                );
            });

            // ==== CỘT TỔNG: NUMBER THUẦN ====
            summaryCols.forEach(c => {
                row.push(
                    user[c.field] !== undefined && user[c.field] !== null
                        ? Number(user[c.field])
                        : 0
                );
            });

            data.push(row);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(data);

        // ÉP KIỂU NUMBER CHO EXCEL (CHỐT)
        Object.keys(worksheet).forEach(key => {
            if (key[0] === '!') return;
            if (typeof worksheet[key].v === 'number') {
                worksheet[key].t = 'n';
            }
        });

        const merges: any[] = [];
        let colIndex = 0;

        fixedCols.forEach(() => {
            merges.push({ s: { r: 0, c: colIndex }, e: { r: 1, c: colIndex } });
            colIndex++;
        });

        colIndex += days.length;

        summaryCols.forEach(c => {
            if (!c.sub) {
                merges.push({ s: { r: 0, c: colIndex }, e: { r: 1, c: colIndex } });
            }
            colIndex++;
        });

        worksheet['!merges'] = merges;

        const workbook = {
            Sheets: { 'Bảng chấm công': worksheet },
            SheetNames: ['Bảng chấm công']
        };

        const worksheet1 = XLSX.utils.aoa_to_sheet([]);

        // add header
        XLSX.utils.sheet_add_aoa(worksheet1, [headerRow1, headerRow2], { origin: 'A1' });

        // add data từ dòng 3
        XLSX.utils.sheet_add_aoa(worksheet1, data.slice(2), { origin: 'A3' });



        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, fileName);
    }

    exportDataUserOffice(dataSource: any[]) {
        if (!dataSource || !dataSource.length) {
            return;
        }

        const exportCols = this.cols.filter(c => c.visible);

        const data = dataSource.map(row => {
            const obj: any = {};

            exportCols.forEach(col => {
                switch (col.field) {

                    case 'organizations':
                        obj[col.header] = (row.organizations || [])
                            .map(x => x.organizationName)
                            .join(', ');
                        break;

                    case 'managers':
                        obj[col.header] = (row.managers || [])
                            .map(x => x.managerName)
                            .join(', ');
                        break;

                    case 'joinDate':
                    case 'createdDate':
                        obj[col.header] = row[col.field]
                            ? new Date(row[col.field]).toLocaleDateString('vi-VN')
                            : '';
                        break;

                    default:
                        obj[col.header] = row[col.field] != null ? row[col.field] : '';
                        break;
                }
            });

            return obj;
        });

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
        const workbook: XLSX.WorkBook = {
            Sheets: { 'Danh sách nhân viên': worksheet },
            SheetNames: ['Danh sách nhân viên']
        };

        XLSX.writeFile(workbook, 'DanhSachNhanVien.xlsx');
    }


    exportExcelBangCongOfficeAI(
        dataSource: any[],
        days: any[],
        cols: any[],
        fileName: string,
        exportByHours: boolean = false
    ) {
        const headerRow1: any[] = [];
        const headerRow2: any[] = [];

        const fixedCols = cols.filter(c =>
            ['stt', 'code', 'codeDap', 'name', 'organization'].includes(c.field) && c.visible
        );

        // ===== HEADER CỐ ĐỊNH =====
        fixedCols.forEach(c => {
            headerRow1.push(c.header);
            headerRow2.push('');
        });

        // ===== HEADER NGÀY =====
        days.forEach(d => {
            headerRow1.push(d.dayOfWeek);
            headerRow2.push(`${d.day}/${d.month}`);
        });

        // ===== CỘT TỔNG =====
        let summaryCols = [
            { field: 'totalMinutesLate', header: 'Đi muộn', sub: 'Số phút' },
            { field: 'totalMinutesEarly', header: 'Về sớm', sub: 'Số phút' },
            { field: 'totalForgotInOut', header: 'Quên chốt', sub: 'Số lần' },

            { field: 'totalLeave', header: 'Nghỉ phép', sub: 'Đầu kỳ' },
            { field: 'userLeave', header: 'Nghỉ phép', sub: 'Sử dụng' },
            { field: 'remainingLeave', header: 'Nghỉ phép', sub: 'Cuối kỳ' },

            { field: 'totalWorkShift', header: 'Công', sub: 'Công ca' },
            { field: 'totalWorkHoliday', header: 'Công', sub: 'Công lễ' },
            { field: 'totalWorkTravel', header: 'Công', sub: 'Công công tác' },

            { field: 'otHolidayHours', header: 'Làm thêm', sub: 'Giờ ngày lễ' },
            { field: 'otOffDayHours', header: 'Làm thêm', sub: 'Giờ ngày nghỉ' },
            { field: 'otDayShiftHours', header: 'Làm thêm', sub: 'Giờ ngày ca' },
            { field: 'totalOtHour', header: 'Làm thêm', sub: 'Số giờ' },
            { field: 'otWork', header: 'Làm thêm', sub: 'Số công' },

            { field: 'totalWorkMonthHours', header: 'Tổng giờ', sub: '' },
            { field: 'totalWork', header: 'Tổng công', sub: '' }
        ];

        if (exportByHours) {
            summaryCols = [
                { field: 'totalMinutesLate', header: 'Đi muộn', sub: 'Số phút' },
                { field: 'totalMinutesEarly', header: 'Về sớm', sub: 'Số phút' },
                { field: 'totalForgotInOut', header: 'Quên chốt', sub: 'Số lần' },

                { field: 'totalLeave', header: 'Nghỉ phép', sub: 'Đầu kỳ' },
                { field: 'userLeave', header: 'Nghỉ phép', sub: 'Sử dụng' },
                { field: 'remainingLeave', header: 'Nghỉ phép', sub: 'Cuối kỳ' },

                { field: 'otHolidayHours', header: 'Làm thêm', sub: 'Giờ ngày lễ' },
                { field: 'otOffDayHours', header: 'Làm thêm', sub: 'Giờ ngày nghỉ' },
                { field: 'otDayShiftHours', header: 'Làm thêm', sub: 'Giờ ngày ca' },
                { field: 'totalOtHour', header: 'Làm thêm', sub: 'Tổng giờ' },

                { field: 'totalWorkedHours', header: 'Tổng giờ làm việc', sub: '' }
            ];
        }

        summaryCols.forEach(c => {
            headerRow1.push(c.header);
            headerRow2.push(c.sub);
        });

        // ===== DATA ROWS (NUMBER THUẦN) =====
        const bodyRows: any[] = [];

        dataSource.forEach((user, index) => {
            const row: any[] = [];

            fixedCols.forEach(c => {
                if (c.field === 'stt') {
                    row.push(index + 1);
                } else {
                    row.push(user[c.field]);
                }
            });

            // ngày
            user.days.forEach(d => {
                const value = exportByHours ? d.workedHours : d.workUnits;
                row.push(value != null ? Number(value) : null);
            });

            // tổng
            summaryCols.forEach(c => {
                if (c.field === 'totalWorkedHours') {
                    const totalWorkedHours = user.days.reduce((total, d) => total + Number(d.workedHours || 0), 0);
                    row.push(Number(totalWorkedHours.toFixed(4)));
                } else {
                    row.push(user[c.field] != null ? Number(user[c.field]) : 0);
                }
            });

            bodyRows.push(row);
        });

        // ===== TẠO WORKSHEET RỖNG =====
        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // add header
        XLSX.utils.sheet_add_aoa(worksheet, [headerRow1, headerRow2], { origin: 'A1' });

        // add data từ dòng 3
        XLSX.utils.sheet_add_aoa(worksheet, bodyRows, { origin: 'A3' });

        // ===== GẮN COMMENT (NOTE) CHO NGÀY P / L / CT =====
        const startCol = fixedCols.length;
        const startRow = 2; // A3

        dataSource.forEach((user, rowIdx) => {
            user.days.forEach((d, dayIdx) => {
                if (!d.type) return;

                const r = startRow + rowIdx;
                const c = startCol + dayIdx;
                const addr = XLSX.utils.encode_cell({ r, c });
                const cell = worksheet[addr];

                if (!cell || typeof cell.v !== 'number') return;

                switch (d.type) {
                    case this.catalogType.DonXinNghi:
                        cell.z = '0.00" (P)"';
                        break;

                    case this.catalogType.NghiLeDacBiet:
                        cell.z = '0.00" (L)"';
                        break;

                    case this.catalogType.DonCongTac:
                        cell.z = '0.00" (CT)"';
                        break;

                    case this.catalogType.NghiBudacBiet:
                        cell.z = '0.00" (B)"';
                        break;

                    case this.catalogType.DonLamThem:
                        cell.z = '0.00" (LT)"';
                        break;

                    case this.catalogType.DonInOut:
                        cell.z = '0.00" (I/O)"';
                        break;
                }
            });
        });



        // ===== ÉP KIỂU NUMBER CHO DATA (KHÔNG ĐỤNG HEADER) =====
        const range = XLSX.utils.decode_range(worksheet['!ref']!);

        for (let r = 2; r <= range.e.r; r++) {
            for (let c = 0; c <= range.e.c; c++) {
                const addr = XLSX.utils.encode_cell({ r, c });
                const cell = worksheet[addr];
                if (!cell) continue;

                if (typeof cell.v === 'number') {
                    cell.t = 'n';
                }
            }
        }

        // ===== MERGE HEADER =====
        const merges: any[] = [];
        let colIndex = 0;

        fixedCols.forEach(() => {
            merges.push({ s: { r: 0, c: colIndex }, e: { r: 1, c: colIndex } });
            colIndex++;
        });

        colIndex += days.length;

        summaryCols.forEach(c => {
            if (!c.sub) {
                merges.push({ s: { r: 0, c: colIndex }, e: { r: 1, c: colIndex } });
            }
            colIndex++;
        });

        worksheet['!merges'] = merges;

        // ===== WORKBOOK =====
        const sheetName = exportByHours ? 'Bảng công theo giờ' : 'Bảng chấm công';
        const workbook = {
            Sheets: { [sheetName]: worksheet },
            SheetNames: [sheetName]
        };

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        this.saveAsExcelFile(excelBuffer, fileName);
    }

    exportExcelBangCongOfficeAIShift(
        dataSource: any[],
        days: any[],
        cols: any[],
        fileName: string
    ) {
        const headerRow1: any[] = [];
        const headerRow2: any[] = [];

        const fixedCols = cols.filter(c =>
            ['stt', 'code', 'codeDap', 'name', 'organization'].includes(c.field) && c.visible
        );

        // ===== HEADER CỐ ĐỊNH =====
        fixedCols.forEach(c => {
            headerRow1.push(c.header);
            headerRow2.push('');
        });

        // ===== HEADER NGÀY =====
        days.forEach(d => {
            headerRow1.push(d.dayOfWeek);
            headerRow2.push(`${d.day}/${d.month}`);
        });

        // ===== CỘT TỔNG =====
        const summaryCols = [

            { field: 'totalLeave', header: 'Nghỉ phép', sub: 'Đầu kỳ' },
            { field: 'userLeave', header: 'Nghỉ phép', sub: 'Sử dụng' },
            { field: 'remainingLeave', header: 'Nghỉ phép', sub: 'Cuối kỳ' },

            { field: 'totalStandardWorkHours', header: 'Tổng giờ', sub: '' },
            { field: 'totalStandardWorkDays', header: 'Công chuẩn', sub: '' }
        ];

        summaryCols.forEach(c => {
            headerRow1.push(c.header);
            headerRow2.push(c.sub);
        });

        // ===== DATA ROWS (NUMBER THUẦN) =====
        const bodyRows: any[] = [];

        dataSource.forEach((user, index) => {
            const row: any[] = [];

            fixedCols.forEach(c => {
                if (c.field === 'stt') {
                    row.push(index + 1);
                } else {
                    row.push(user[c.field]);
                }
            });

            // ngày
            user.days.forEach(d => {
                row.push(d.codeVacationShift || '');
            });

            // tổng
            summaryCols.forEach(c => {
                row.push(user[c.field] != null ? Number(user[c.field]) : 0);
            });

            bodyRows.push(row);
        });

        // ===== TẠO WORKSHEET RỖNG =====
        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // add header
        XLSX.utils.sheet_add_aoa(worksheet, [headerRow1, headerRow2], { origin: 'A1' });

        // add data từ dòng 3
        XLSX.utils.sheet_add_aoa(worksheet, bodyRows, { origin: 'A3' });

        // ===== GẮN COMMENT (NOTE) CHO NGÀY P / L / CT =====
        const startCol = fixedCols.length;
        const startRow = 2; // A3

        dataSource.forEach((user, rowIdx) => {
            user.days.forEach((d, dayIdx) => {
                if (!d.type) return;

                const r = startRow + rowIdx;
                const c = startCol + dayIdx;
                const addr = XLSX.utils.encode_cell({ r, c });
                const cell = worksheet[addr];

                if (!cell || typeof cell.v !== 'number') return;

            });
        });

        // ===== MERGE HEADER =====
        const merges: any[] = [];
        let colIndex = 0;

        fixedCols.forEach(() => {
            merges.push({ s: { r: 0, c: colIndex }, e: { r: 1, c: colIndex } });
            colIndex++;
        });

        colIndex += days.length;

        summaryCols.forEach(c => {
            if (!c.sub) {
                merges.push({ s: { r: 0, c: colIndex }, e: { r: 1, c: colIndex } });
            }
            colIndex++;
        });

        worksheet['!merges'] = merges;

        // ===== WORKBOOK =====
        const workbook = {
            Sheets: { 'Bảng chấm công': worksheet },
            SheetNames: ['Bảng chấm công']
        };

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        this.saveAsExcelFile(excelBuffer, fileName);
    }

    exportExcelStaffInsurance(dataSource: any[], month: number, year: number) {

        const fileName = `Danh_sach_nhan_vien_tham_gia_bao_hiem_T${month}_${year}`;

        const headerRow1: any[] = [];
        const headerRow2: any[] = [];
        const bodyRows: any[] = [];

        const first = (dataSource && dataSource.length > 0) ? dataSource[0] : {};

        const rateCompanyBHXH = first.rateCompanyBHXH || 0;
        const rateCompanyBHYT = first.rateCompanyBHYT || 0;
        const rateCompanyBHTN = first.rateCompanyBHTN || 0;

        const rateBHXH = first.rateBHXH || 0;
        const rateBHYT = first.rateBHYT || 0;
        const rateBHTN = first.rateBHTN || 0;

        // ===== HEADER DÒNG 1 =====
        headerRow1.push('STT');
        headerRow1.push('Họ và tên');
        headerRow1.push('Số sổ BHXH');
        headerRow1.push('Vị trí');
        headerRow1.push(`Mức lương BH (${month}/${year})`);

        headerRow1.push('Phần Công ty phải nộp');
        headerRow1.push('');
        headerRow1.push('');
        headerRow1.push('');

        headerRow1.push('Phần Người lao động phải nộp');
        headerRow1.push('');
        headerRow1.push('');
        headerRow1.push('');

        headerRow1.push('Tổng cộng phải nộp BHXH');
        headerRow1.push('Tháng báo tăng BH');

        // ===== HEADER DÒNG 2 =====
        headerRow2.push('');
        headerRow2.push('');
        headerRow2.push('');
        headerRow2.push('');
        headerRow2.push('');

        headerRow2.push(`BHXH (${rateCompanyBHXH}%)`);
        headerRow2.push(`BHYT (${rateCompanyBHYT}%)`);
        headerRow2.push(`BHTN (${rateCompanyBHTN}%)`);
        headerRow2.push('Tổng cộng');

        headerRow2.push(`BHXH (${rateBHXH}%)`);
        headerRow2.push(`BHYT (${rateBHYT}%)`);
        headerRow2.push(`BHTN (${rateBHTN}%)`);
        headerRow2.push('Tổng cộng');

        headerRow2.push('');
        headerRow2.push('');

        // ===== DATA =====
        dataSource.forEach((item, index) => {
            const row: any[] = [];

            row.push(index + 1);
            row.push(item.name || '');
            row.push(item.bookNumber || '');
            row.push(item.positionName || '');
            row.push(item.baseSalaryInssurance != null ? Number(item.baseSalaryInssurance) : 0);

            row.push(item.companyBHXH != null ? Number(item.companyBHXH) : 0);
            row.push(item.companyBHYT != null ? Number(item.companyBHYT) : 0);
            row.push(item.companyBHTN != null ? Number(item.companyBHTN) : 0);
            row.push(item.companyTotal != null ? Number(item.companyTotal) : 0);

            row.push(item.employeeBHXH != null ? Number(item.employeeBHXH) : 0);
            row.push(item.employeeBHYT != null ? Number(item.employeeBHYT) : 0);
            row.push(item.employeeBHTN != null ? Number(item.employeeBHTN) : 0);
            row.push(item.employeeTotal != null ? Number(item.employeeTotal) : 0);

            row.push(item.totalInsurance != null ? Number(item.totalInsurance) : 0);
            row.push(this.getStartMonthYear(item.startDate) || '');

            bodyRows.push(row);
        });

        const worksheet = XLSX.utils.aoa_to_sheet([]);

        XLSX.utils.sheet_add_aoa(worksheet, [headerRow1, headerRow2], { origin: 'A1' });
        XLSX.utils.sheet_add_aoa(worksheet, bodyRows, { origin: 'A3' });

        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
            { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
            { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } },
            { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } },
            { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } },

            { s: { r: 0, c: 5 }, e: { r: 0, c: 8 } },
            { s: { r: 0, c: 9 }, e: { r: 0, c: 12 } },

            { s: { r: 0, c: 13 }, e: { r: 1, c: 13 } },
            { s: { r: 0, c: 14 }, e: { r: 1, c: 14 } }
        ];

        worksheet['!cols'] = [
            { wch: 6 },
            { wch: 28 },
            { wch: 18 },
            { wch: 22 },
            { wch: 18 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 18 },
            { wch: 18 }
        ];

        const moneyCols = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
        for (let row = 2; row < bodyRows.length + 2; row++) {
            moneyCols.forEach(col => {
                const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
                if (worksheet[cellRef]) {
                    worksheet[cellRef].z = '#,##0';
                }
            });
        }

        const workbook = {
            Sheets: { 'Danh sách bảo hiểm': worksheet },
            SheetNames: ['Danh sách bảo hiểm']
        };

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        this.saveAsExcelFile(excelBuffer, `${fileName}.xlsx`);
    }

    getStartMonthYear(startDate: string): string {
        if (!startDate) return '';

        const d = new Date(startDate);
        if (isNaN(d.getTime())) return '';

        const month = d.getMonth() + 1;
        return `${month < 10 ? '0' + month : month}/${d.getFullYear()}`;
    }

    exportExcelBangCong(dataSource: any[], days: any[], fileName: string) {
        const headerRow1 = ['Mã Dap', 'Mã NV', 'Họ và Tên', 'Vị trí'];
        const headerRow2 = ['', '', '', ''];

        days.forEach(day => {
            headerRow1.push(day.dayOfWeek);
            headerRow2.push(day.day);
        });

        const tongFields = [
            { field: 'tongCongHopLe', label: 'Ngày công hợp lệ' },
            { field: 'tongCongKhongHopLe', label: 'Ngày công không hợp lệ' },
            { field: 'tongNgayNghiPhep', label: 'Ngày nghỉ phép' },
            { field: 'tongNgayNghiLe', label: 'Ngày nghỉ lễ' },
            { field: 'tongNgayLamViec', label: 'Tổng ngày làm việc thực tế' },
            { field: 'totalWork', label: 'Công chuẩn' },
        ];

        tongFields.forEach(f => {
            headerRow1.push(f.label);
            headerRow2.push('');
        });

        const data = [];
        data.push(headerRow1);
        data.push(headerRow2);

        dataSource.forEach((user, index) => {
            const row = [];
            row.push(user.codeDap);
            row.push(user.code);
            row.push(user.name);
            row.push(user.organization);

            user.days.forEach(d => {
                let cellValue = `${d.workUnits}`;
                if (d.type === 1) cellValue += ' (P)';
                if (d.type === 2) cellValue += ' (L)';
                if (d.type === 3) cellValue += ' (DT)';
                if (d.type === 4) cellValue += ' (B)';
                row.push(cellValue);
            });

            tongFields.forEach(f => row.push(user[f.field] != null ? user[f.field] : 0));

            data.push(row);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(data);

        const merges = [
            { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Mã Dap
            { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // Mã NV
            { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // Họ và tên
            { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // Vị trí
        ];

        const totalColumnCount = 4 + days.length;
        tongFields.forEach((f, idx) => {
            merges.push({
                s: { r: 0, c: totalColumnCount + idx },
                e: { r: 1, c: totalColumnCount + idx }
            });
        });

        worksheet['!merges'] = merges;

        const workbook = {
            Sheets: { 'Bảng chấm công': worksheet },
            SheetNames: ['Bảng chấm công']
        };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, fileName);
    }


    exportExcelGroupTdv(treeData: TreeNode[]) {
        const data = [];

        const flattenTree = (nodes: TreeNode[], parentName = '') => {
            nodes.forEach(node => {
                const row = {
                    'Tên Nhóm': parentName ? `${parentName} > ${node.data.name}` : node.data.name,
                    'Số nhà thuốc': node.data.totalNt || 0,
                    'Số đơn hàng': node.data.totalOrder || 0,
                    'Doanh số': node.data.total || 0
                };
                data.push(row);

                if (node.children && node.children.length > 0) {
                    flattenTree(node.children, row['Tên Nhóm']);
                }
            });
        };

        flattenTree(treeData);

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        this.saveAsExcelFile(excelBuffer, 'TreeData_Export');
    }
    exportExcelFull(dataSource) {
        const data = [];
        dataSource.forEach(item => {
            const row = {};
            this.cols.forEach(col => {
                let celValue = item[col.field];
                if (celValue) {// Format Date
                    if (col.dataType === 'date') {
                        celValue = moment.utc(celValue).format('YYYY-MM-DD HH:mm');
                    }
                    if (col.dataType === 'number') {
                        //celValue = (celValue).toLocaleString('vi-VN', { maximumFractionDigits: 4 });
                        celValue = (celValue);
                    }
                }
                if (col.field === 'location') {
                    celValue = `${item.lat}, ${item.lng}`;
                }

                if (col.field === 'dateCheckIn') {
                    celValue = `CheckIn: ${item.dateCheckIn} - CheckOut: ${item.dateCheckOut}`;
                }

                if (col.field === 'deviceInfo') {
                    celValue = `(Device: ${item.device || 'Không xác định'}, 
                                 DeviceName: ${item.deviceName || 'Không xác định'}, 
                                 AppVersion: ${item.appVersion || 'Không xác định'}, 
                                 Platform: ${item.platForm || 'Không xác định'}, 
                                 OsVersion: ${item.osVersion || 'Không xác định'})`;
                }

                row[col.header] = celValue;
            });
            data.push(row);
        });
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, this.exportName);
    }

    exportExcelFullV2(dataSource) {
        const data = [];
        const row = {};
        var index = 0;
        this.cols.forEach(col => {
            row[col.field] = col.header;
            index++;
        });
        dataSource.unshift(row);
        const worksheet = XLSX.utils.json_to_sheet(dataSource, { skipHeader: true });
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, this.exportName);
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    delete(id: number) {
        this._notifierService.showDeleteConfirm().then(rs => {
            this._baseService.delete(id)
                .then(response => {
                    this.getData();
                }, error => {
                    this._notifierService.showDeleteDataSuccess();
                });
        });
    }
    deletelstMany() {
        let lstId = '';
        for (var item of this.ids) {
            lstId += item.id + ",";
        }
        lstId = lstId.substring(0, lstId.length - 1);
        this._baseService.deleteMany(lstId).then(response => {
            this.getData();
        }, error => {
            this._notifierService.showHttpUnknowError();
        });
    }
    deleteMutiple() {
        this._notifierService.showDeleteConfirm().then(rs => {

            // const obs   = new Subject<number>();
            // let   index = 0;

            // this.selectedItems.forEach(item => {
            //     this._baseService.delete(item.id)
            //         .then(response => {
            //             obs.next(++index);
            //             // this._notifierService.showDeleteDataSuccess();
            //         }, error => {
            //             obs.next(++index);
            //             // this._notifierService.showDeleteDataError();
            //         });
            // });

            // const sub = obs.subscribe(indexItem => {
            //     if (indexItem === this.selectedItems.length) {
            //         this.selectedItems.length = 0;
            //         sub.unsubscribe();
            //         this.getData();
            //         this._notifierService.showDeleteDataSuccess();
            //     }
            // });
            this.deletelstMany();
            this._notifierService.showDeleteDataSuccess();
        });
    }



    // deleteMutiple() {
    //     this._notifierService.showDeleteConfirm().then(rs => {

    //         const obs   = new Subject<number>();
    //         let   index = 0;

    //         this.selectedItems.forEach(item => {
    //             this._baseService.delete(item.id)
    //                 .then(response => {
    //                     obs.next(++index);
    //                     // this._notifierService.showDeleteDataSuccess();
    //                 }, error => {
    //                     obs.next(++index);
    //                     // this._notifierService.showDeleteDataError();
    //                 });
    //         });

    //         const sub = obs.subscribe(indexItem => {
    //             if (indexItem === this.selectedItems.length) {
    //                 this.selectedItems.length = 0;
    //                 sub.unsubscribe();
    //                 this.getData();
    //                 this._notifierService.showDeleteDataSuccess();
    //             }
    //         });
    //     });
    // }

    afterGetData() {

    }

    onSearch(): void {
        this.page = 1;
        this.getData();
        // this.openSearchAdv = false;
    }

    goToPage(event: any): void {
        this.page = (event.first / event.rows) + 1;
        this.limit = event.rows;
        this.getData();
    }

    onNext(): void {
        this.page++;
        this.getData();
    }

    onPrev(): void {
        this.page--;
        this.getData();
    }

    onSort(event: any) {
        this.sortField = event.field;
        this.isAsc = event.order === 1 ? false : true;
        this.getData();
    }

    onChangeSize(): void {
        this.page = 1;
        this.getData();
    }

    viewActivities(): void {
        this.isViewActivity = !this.isViewActivity;
    }

    viewSettings(): void {
        this.isViewSetting = !this.isViewSetting;
    }

    onPage(event: any): void {
        this.page = (event.first / event.rows) + 1;
        this.limit = event.rows;
        this.getData();
    }

    checkItem(item) {
        if (item.checked) {
            this.ids.push(item.id);
            item.checked = true;
        } else {
            this.ids.splice(this.ids.indexOf(item.id), 1);
            item.checked = false;
        }
        this.isMultiEdit = this.ids.length > 0 ? true : false;
        this.isCheckAll = this.ids.length === this.dataSource.length ? true : false;
    }

    splitYearMonth = (s: any): { year: number; month: number } | null => {
        if (typeof s !== 'string') return null;

        const parts = s.split('-');
        if (parts.length !== 2) return null;

        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);

        if (isNaN(year) || isNaN(month) || month < 1 || month > 12) return null;

        return { year, month };
    };

    onCheckAll(ev) {
        if (ev.target.checked) {
            this.isCheckAll = true;
            this.ids = [];
            for (let i = 0; i < this.dataSource.length; i++) {
                this.dataSource[i].checked = true;
                this.ids.push(this.dataSource[i].id);
            }
        } else {
            this.isCheckAll = false;
            this.ids = [];
            for (let i = 0; i < this.dataSource.length; i++) {
                this.dataSource[i].checked = false;
            }
        }
        this.isMultiEdit = this.ids.length > 0 ? true : false;
    }

    checkItemMenu(type: number) {
        this.ids = [];
        for (let i = 0; i < this.dataSource.length; i++) {
            if (type === -1) {
                this.dataSource[i].checked = true;
                this.ids.push(this.dataSource[i].id);
            } else if (type === -2) {
                this.dataSource[i].checked = false;
            } else {
                if (this.dataSource[i].trangThai === type) {
                    this.dataSource[i].checked = true;
                    this.ids.push(this.dataSource[i].id);
                }
            }
        }
        this.openSelectCheck = false;
        this.isMultiEdit = this.ids.length > 0 ? true : false;
        this.isCheckAll = this.ids.length === this.dataSource.length ? true : false;
    }

    paginate(event) {
        this.page = event.page + 1;
        this.limit = event.rows;
        this.getData();
    }

    onSelectionChanged(event) {
        this.selectedItems = event;
    }

    containSelectItem(item) {
        return this.selectedItems.findIndex(x => x.id === item.id) > -1;
    }

    onPopupClosed(data) {
        if (data) {
            this.getData();
        }
    }

    printListLoaiDiemById(ids: string, data: any[]) {
        let str = '';
        const arr = ids.split(',');
        for (let i = 0; i < arr.length - 1; i++) {
            const tg = data.filter(item => item.id === +arr[i]);
            str += tg[0].ma + ', ';
        }
        const tgs = data.filter(item => item.id === +arr[arr.length - 1]);
        str += tgs[0].ma;

        return str;
    }

    convertDataToOptions(options: any[], data: any[], fieldName: string) {
        if (data.length > 0) {
            data.map(item =>
                options.push({ label: item[fieldName], value: item.id })
            );
        }
    }

    getFieldById(data: any[], id: number, fieldName: string) {
        for (const i in data) {
            const item = data[i];

            if (item.id === id) {
                return item[fieldName];
            }
        }

        return id;
    }
    toggleColumnList() {
        this.openColumnList = !this.openColumnList;
    }

    resetBulkSelect() {
        this.ids = [];
        this.selectedItems = [];
        this.isCheckAll = false;
    }

    getIndexDataById(id: number) {
        return this.dataSource.findIndex(i => i.id === id);
    }

    getDataById(id: number) {
        const index = this.dataSource.findIndex(i => i.id === id);
        return this.dataSource[index];
    }

    onPrint() {
        const d = new Printd();
        d.print(document.getElementById('table'), [cssText]);
    }
    onPrintE(element: string) {
        const d = new Printd();
        d.print(document.getElementById(element), [cssText]);
    }

    onSaveSettings(event: any) {
        // if (event.checkCols === true) {
        //     this.mySettings.cols = JSON.stringify(this.cols);
        // } else {
        //     this.mySettings.cols = undefined;
        // }
        // if (event.checkSearch === true) {
        //     this.mySettings.openSearchAdv = this.openSearchAdv;
        // }
        // this._tnUserSettingsService.updateSettingForUrl(this.mySettings).then(rs => {
        //     if (rs.status) {
        //         this.mySettings = rs.data;
        //         if (this.mySettings.cols !== null && this.mySettings.cols !== undefined) {
        //             this.cols = JSON.parse(this.mySettings.cols);
        //         }
        //         this.pSetting.onLoadSetting(this.mySettings);
        //         this._notifierService.showUpdateDataSuccess();
        //     } else {
        //         this._notifierService.showUpdateDataFailed();
        //     }
        // });
    }

    getMaxDialogHeight() {
        return (window.innerHeight - 200).toString() + 'px';
    }

    onRowSelect(event) {
        this.ids.push(event.data.id);
        event.data.checked = true;

        this.isMultiEdit = this.ids.length > 0 ? true : false;
        this.isCheckAll = this.ids.length === this.dataSource.length ? true : false;
    }
    onRowUnselect(event) {
        this.ids.splice(this.ids.indexOf(event.data.id), 1);
        event.data.checked = false;

        this.isMultiEdit = this.ids.length > 0 ? true : false;
        this.isCheckAll = this.ids.length === this.dataSource.length ? true : false;
    }

    // GetStatus(item: any) {
    //     if (item.idStatus === 1000) {
    //         return `<span class="order don-moi">${item.status}</span>`;
    //     }
    //     if (item.idStatus === 31 || item.idStatus === 32) {
    //         return `<span class="order don-thanhcong">${item.status}</span>`;
    //     }
    //     if (item.idStatus === 22 || item.idStatus === 33) {
    //         return `<span class="order don-nguyhiem">${item.status}</span>`;
    //     }
    //     if (item.idStatus === 4 || item.idStatus === 40 || item.idStatus === 41 || item.idStatus === 999) {
    //         return `<span class="order don-thatbai">${item.status}</span>`;
    //     } else {
    //         return `<span class="order don-danggiao">${item.status}</span>`;
    //     }
    // }

    formatPhone(phone): string {
        const re = new RegExp(/^((84|0[3|5|7|8|9])+([0-9]{8})\b)$/);
        if (re.test(phone)) {
            phone = phone.substring(0, 4) + '***' + phone.substring(7);
        }
        return phone;
    }
    onChangeRowLimit() {
        this.onSearch();
        this.fixTableScrollProblem();
    }
    // fix vụ lệch header ở table khi xuất hiện thanh scroll
    fixTableScrollProblem() {
        this.dataSource = [...this.dataSource];
    }

    mapJsonToDetailAddress(data: any): DetailAddress {
        return {
            place_id: data.place_id,
            licence: data.licence,
            osm_type: data.osm_type,
            osm_id: data.osm_id,
            lat: data.lat,
            lon: data.lon,
            class: data.class,
            type: data.type,
            place_rank: data.place_rank,
            importance: data.importance,
            addresstype: data.addresstype,
            name: data.name,
            display_name: data.display_name,
            address: {
                road: data.address.road,
                quarter: data.address.quarter,
                suburb: data.address.suburb,
                city: data.address.city,
                ISO3166_2_lvl4: data.address.ISO3166_2_lvl4,
                postcode: data.address.postcode,
                country: data.address.country,
                country_code: data.address.country_code
            },
            boundingbox: data.boundingbox
        };
    }
}
